/**
 * 客戶表單欄位工具（來源選項與正規化）
 */

/**
 * 來源值正規化：資料庫存大寫代碼（OTHER、SOCIAL_MEDIA；後端 normalizeCustomerSource 寫入時轉換），
 * 前端選項與翻譯 key 是 other／socialMedia；載入與顯示前一律轉成前端格式，避免下拉選單空白
 */
export const normalizeSource = (source?: string | null): string => {
  if (!source) return 'other';
  // 只轉換全大寫的資料庫值（SOCIAL_MEDIA → socialMedia）；已是前端格式（socialMedia）就原樣回傳，可重複呼叫
  return /^[A-Z_]+$/.test(source)
    ? source.toLowerCase().replace(/_([a-z])/g, (_, c: string) => c.toUpperCase())
    : source;
};

/**
 * 客戶來源選項
 */
export const getSourceOptions = (t: (key: string, options?: any) => string) => [
  { value: 'website', label: t('common.forms.sources.website') },
  { value: 'referral', label: t('common.forms.sources.referral') },
  { value: 'advertisement', label: t('common.forms.sources.advertisement') },
  { value: 'exhibition', label: t('common.forms.sources.exhibition') },
  { value: 'telemarketing', label: t('common.forms.sources.telemarketing') },
  { value: 'socialMedia', label: t('common.forms.sources.socialMedia') },
  { value: 'other', label: t('common.forms.sources.other') }
];
